export default __webpack_public_path__ + "static/media/icon-request-cancel.364fc279.svg";